<button mat-icon-button [matTooltip]="'Edit'" [intercomTarget]="'toolbar-context-menu-edit'" (click)="editClick.emit()">
  <mat-icon>edit</mat-icon>
</button>
